module.exports = __webpack_public_path__ + "img/align-left-01.b22103f7.svg";